export default "__VITE_ASSET__c59LwbyP__"